import {useRef} from "react";
import {observer} from "mobx-react";
import { useResizeDetector } from 'react-resize-detector';
import appLayoutStore from "../../../../stores/app-layout-store";
import MerchantPortalsMenu from "./merchant-portals-menu/merchant-portals-menu";
import dashboardSettingsStore from "../../../../stores/dashboard-settings-store";
import HelpCenterMenu from "./help-center-menu/help-center-menu";
import PersonalAreaMenu from "./personal-area-menu/personal-area-menu";
import SidebarBurgerMenu from "./sidebar-toggle/sidebar-burger-menu";
import Logo from "./logo/logo";
import HeaderNotifications from "./header-notifications/header-notifications";
import { isSet } from "../../../../models/model-types-methods";

const AppHeader = observer(() => {
    const appHeaderRef = useRef<HTMLElement>(null);
    useResizeDetector({
        targetRef: appHeaderRef,
        observerOptions: { box: 'border-box' },
        onResize: ({ height }) => {
            if (isSet(height)) {
                appLayoutStore.headerHeight = height;
            }
        },
    });

    return (
        <header className="app-header" ref={appHeaderRef}>
            <div className="app-header-items-container">
                <SidebarBurgerMenu />
                <Logo theme={dashboardSettingsStore.themeName}/>
                <MerchantPortalsMenu />
            </div>
            <div className="app-header-items-container">
                <HeaderNotifications />
                <HelpCenterMenu />
                <PersonalAreaMenu />
            </div>
        </header>
    );
});

export default AppHeader;
